/**
 * Language utility functions
 * Provides helpers for working with i18n language codes
 */

/**
 * Extracts the base language code from a full locale string
 * @param {string} languageCode - Full language code (e.g., 'bg-BG', 'en-US')
 * @returns {string} Base language code (e.g., 'bg', 'en')
 *
 * @example
 * getBaseLanguage('bg-BG') // returns 'bg'
 * getBaseLanguage('en-US') // returns 'en'
 * getBaseLanguage('bg') // returns 'bg'
 */
export const getBaseLanguage = (languageCode) => {
  if (!languageCode) return 'bg'; // Default fallback
  return languageCode.split('-')[0];
};

/**
 * Gets the current base language from i18n instance
 * @param {Object} i18n - i18next instance
 * @returns {string} Base language code
 *
 * @example
 * const currentLang = getCurrentLanguage(i18n); // returns 'bg' or 'en'
 */
export const getCurrentLanguage = (i18n) => {
  return getBaseLanguage(i18n.language);
};

/**
 * Common language codes used in the application
 */
export const LANGUAGES = {
  BG: 'bg',
  EN: 'en',
};

/**
 * Language display names
 */
export const LANGUAGE_NAMES = {
  bg: 'Български',
  en: 'English',
};
